require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-z-hix-wa.json") })
        }
      }, "path---photos-professional-z-hix-wa");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-z-hix-wa!./.cache/json/photos-professional-z-hix-wa.json
// module id = 1160
// module chunks = 231608221292675